import "@arco-design/web-react/es/Table/style";
import _Table from "@arco-design/web-react/es/Table";
import React from 'react';
import GuideLayout from '../GuideLayout';
import MermaidChart from '../MermaidChart';
import styles from '../style/index.module.less';
const fullFlowChart = `graph TD
    A["需求池\n（MRP 自动推送）"] --> B{"选择采购方式"}
    B -->|"多家比价"| C["发布竞价/询价"]
    B -->|"指定供应商"| D["直接建采购单"]
    C --> E["供应商在线报价"]
    E --> F["比价 & 择优"]
    F --> D
    D --> G["发布采购订单"]
    G --> H["供应商确认/磋商"]
    H --> I["订单确认"]
    I --> J["供应商发货"]
    J --> K["收货 & 品检"]
    K --> L["对账"]
    L --> M["付款"]

    style A fill:#E3F2FD,stroke:#2196F3
    style F fill:#FFF3E0,stroke:#FF9800
    style K fill:#FFEBEE,stroke:#F44336
    style M fill:#F3E5F5,stroke:#9C27B0`;
const statusChart = `stateDiagram-v2
    [*] --> 草稿 : 新建采购单
    草稿 --> 磋商中 : 发布
    草稿 --> [*] : 删除
    磋商中 --> 已确认 : 双方达成一致\n（供应商确认 或 采购方同意）
    磋商中 --> 草稿 : 撤销
    已确认 --> 已确认 : 变更（新版本）`;
const statusColumns = [{
  title: '状态',
  dataIndex: 'status'
}, {
  title: '含义',
  dataIndex: 'meaning'
}, {
  title: '你能做什么',
  dataIndex: 'action'
}, {
  title: '条件',
  dataIndex: 'condition'
}];
const statusData = [{
  status: '草稿',
  meaning: '刚创建',
  action: '编辑物料/价格、发布、删除',
  condition: '—'
}, {
  status: '磋商中',
  meaning: '已发给供应商，等待确认',
  action: '出价、改价、变更、撤销',
  condition: '供应商可报价/还价'
}, {
  status: '已确认',
  meaning: '双方达成一致',
  action: '供应商发货、变更、下载合同',
  condition: '双方价格/交期已对齐'
}];
const methodColumns = [{
  title: '方式',
  dataIndex: 'method'
}, {
  title: '适用场景',
  dataIndex: 'scene'
}, {
  title: '流程',
  dataIndex: 'flow'
}];
const methodData = [{
  method: '询价',
  scene: '常规物料，向指定供应商询问价格',
  flow: '选物料 → 选供应商 → 发询价 → 供应商报价 → 采纳 → 生成订单'
}, {
  method: '竞价',
  scene: '重要物料，多家供应商竞争',
  flow: '选物料 → 邀请多家供应商 → 供应商竞价 → 择优 → 生成订单'
}, {
  method: '直接下单',
  scene: '已谈好价格/长期合作供应商',
  flow: '选供应商 → 选物料 → 填价格 → 发布'
}];
const deliveryAlertChart = `graph LR
    A["系统推送\\n交期确认请求"] --> B{"供应商反馈"}
    B -->|"正常"| C["按计划收货"]
    B -->|"延迟"| D["供应商给出新交期"]
    D --> E["你收到预警通知"]
    E --> F{"你的决策"}
    F -->|"催货"| G["联系供应商加急"]
    F -->|"换供应商"| H["启动备选采购"]
    F -->|"调整生产"| I["通知生产排期调整"]`;
const matchChart = `graph LR
    A["物料"] --> B["供应商标签\n（供货范围）"]
    A --> C["材质/品牌"]
    D["供应商"] --> E["供货范围标签"]
    D --> F["材质/品牌标签"]
    B --> G{"匹配"}
    E --> G
    C --> G
    F --> G
    G -->|"标签都匹配"| H["进入候选列表"]
    G -->|"不匹配"| I["不会出现"]

    style H fill:#E8F5E9,stroke:#4CAF50
    style I fill:#FFEBEE,stroke:#F44336`;
const matchColumns = [{
  title: '匹配维度',
  dataIndex: 'dimension'
}, {
  title: '物料侧',
  dataIndex: 'material'
}, {
  title: '供应商侧',
  dataIndex: 'supplier'
}, {
  title: '匹配规则',
  dataIndex: 'rule'
}];
const matchData = [{
  dimension: '供货范围',
  material: '物料的「供应商标签」',
  supplier: '供应商设置的「供货范围标签」（可多个）',
  rule: '物料标签必须命中供应商的某个供货范围标签'
}, {
  dimension: '材质/品牌',
  material: '物料的「材质/品牌」字段',
  supplier: '供应商设置的「材质/品牌标签」（可多个）',
  rule: '物料的材质/品牌必须命中供应商的某个材质/品牌标签'
}];
const scopeChart = `graph LR
    A["需求池\n（MRP 推送）"] --> B{"按管理范围分流"}
    B -->|"标签 A"| C["采购员甲"]
    B -->|"标签 B"| D["采购员乙"]
    B -->|"标签 C"| E["采购员丙"]
    C --> F["各自处理\n自己范围内的需求"]
    D --> F
    E --> F

    style B fill:#FFF3E0,stroke:#FF9800`;
const sections = [{
  id: 'full-flow',
  label: '采购全流程'
}, {
  id: 'supplier-match',
  label: '供应商自动匹配'
}, {
  id: 'scope',
  label: '采购分工与管理范围'
}, {
  id: 'status-flow',
  label: '采购订单状态流转'
}, {
  id: 'methods',
  label: '询价 vs 竞价 vs 直接下单'
}, {
  id: 'change',
  label: '订单变更'
}, {
  id: 'delivery-alert',
  label: '交期预警'
}, {
  id: 'supplier-view',
  label: '供应商视角'
}];
export default function PurchaseGuide() {
  return /*#__PURE__*/React.createElement(GuideLayout, {
    title: "\u91C7\u8D2D\u2014\u2014\u4ECE\u9700\u6C42\u5230\u4ED8\u6B3E\u7684\u5168\u6D41\u7A0B",
    firstQuestion: "\u9700\u6C42\u6765\u4E86\uFF0C\u6211\u8BE5\u600E\u4E48\u4E70\uFF1F\u6BCF\u4E00\u6B65\u8BE5\u770B\u4EC0\u4E48\u3001\u70B9\u4EC0\u4E48\uFF1F",
    sections: sections
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "full-flow"
  }, /*#__PURE__*/React.createElement("h2", null, "\u91C7\u8D2D\u5168\u6D41\u7A0B"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: fullFlowChart
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "supplier-match"
  }, /*#__PURE__*/React.createElement("h2", null, "\u4F9B\u5E94\u5546\u81EA\u52A8\u5339\u914D"), /*#__PURE__*/React.createElement("blockquote", null, "\u53D1\u5E03\u7ADE\u4EF7\u3001\u8BE2\u4EF7\u6216\u91C7\u8D2D\u8BA2\u5355\u65F6\uFF0C\u7CFB\u7EDF\u4F1A\u81EA\u52A8\u7B5B\u9009\u51FA\u7B26\u5408\u6761\u4EF6\u7684\u4F9B\u5E94\u5546\u5019\u9009\u5217\u8868\uFF0C\u800C\u4E0D\u662F\u8BA9\u4F60\u624B\u52A8\u6311\u3002"), /*#__PURE__*/React.createElement("h3", null, "\u5339\u914D\u903B\u8F91"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: matchChart
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: matchColumns,
    data: matchData,
    pagination: false,
    size: "default",
    border: true
  })), /*#__PURE__*/React.createElement("h3", null, "\u64CD\u4F5C\u8981\u70B9"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u7269\u6599\u5FC5\u987B\u8BBE\u7F6E\u4F9B\u5E94\u5546\u6807\u7B7E\u548C\u6750\u8D28/\u54C1\u724C"), "\u2014\u2014\u5426\u5219\u7CFB\u7EDF\u65E0\u6CD5\u81EA\u52A8\u5339\u914D\uFF0C\u5019\u9009\u5217\u8868\u4F1A\u4E3A\u7A7A"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u4F9B\u5E94\u5546\u5FC5\u987B\u8BBE\u7F6E\u5BF9\u5E94\u7684\u4F9B\u8D27\u8303\u56F4\u548C\u6750\u8D28/\u54C1\u724C\u6807\u7B7E"), "\u2014\u2014\u5728\u4F9B\u5E94\u5546\u6863\u6848\u4E2D\u7EF4\u62A4"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u4E24\u4E2A\u7EF4\u5EA6\u90FD\u8981\u5339\u914D"), "\u2014\u2014\u4F9B\u8D27\u8303\u56F4\u548C\u6750\u8D28/\u54C1\u724C\u7F3A\u4E00\u4E0D\u53EF"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u5019\u9009\u5217\u8868\u4E3A\u7A7A\u65F6\u68C0\u67E5\u6807\u7B7E\u914D\u7F6E"), "\u2014\u2014\u5148\u786E\u8BA4\u7269\u6599\u6807\u7B7E\u548C\u4F9B\u5E94\u5546\u6807\u7B7E\u662F\u5426\u80FD\u5BF9\u4E0A"))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "scope"
  }, /*#__PURE__*/React.createElement("h2", null, "\u91C7\u8D2D\u5206\u5DE5\u4E0E\u7BA1\u7406\u8303\u56F4"), /*#__PURE__*/React.createElement("blockquote", null, "\u591A\u4E2A\u91C7\u8D2D\u4EBA\u5458\u53EF\u4EE5\u5206\u5DE5\u5408\u4F5C\uFF0C\u5404\u81EA\u7BA1\u7406\u4E00\u90E8\u5206\u4F9B\u5E94\u5546\u3002\u7CFB\u7EDF\u5728\u9700\u6C42\u6C60\u73AF\u8282\u5C31\u81EA\u52A8\u5206\u6D41\uFF0C\u6BCF\u4E2A\u91C7\u8D2D\u53EA\u770B\u5230\u81EA\u5DF1\u8303\u56F4\u5185\u7684\u9700\u6C42\u3002"), /*#__PURE__*/React.createElement("h3", null, "\u5206\u6D41\u673A\u5236"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: scopeChart
  })), /*#__PURE__*/React.createElement("h3", null, "\u64CD\u4F5C\u8981\u70B9"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u6BCF\u4E2A\u91C7\u8D2D\u4EBA\u5458\u8BBE\u7F6E\u7BA1\u7406\u8303\u56F4"), "\u2014\u2014\u5BF9\u5E94\u4F9B\u5E94\u5546\u6807\u7B7E\uFF0C\u51B3\u5B9A\u80FD\u770B\u5230\u54EA\u4E9B\u9700\u6C42"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u9700\u6C42\u6C60\u81EA\u52A8\u5206\u6D41"), "\u2014\u2014MRP \u751F\u6210\u7684\u91C7\u8D2D\u4EFB\u52A1\u6839\u636E\u7269\u6599\u7684\u4F9B\u5E94\u5546\u6807\u7B7E\u81EA\u52A8\u5206\u914D\u5230\u5BF9\u5E94\u91C7\u8D2D"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u4E00\u4E2A\u91C7\u8D2D\u53EF\u7BA1\u591A\u4E2A\u6807\u7B7E"), "\u2014\u2014\u7BA1\u7406\u8303\u56F4\u53EF\u8BBE\u7F6E\u591A\u4E2A\u4F9B\u5E94\u5546\u6807\u7B7E"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u5206\u5DE5\u660E\u786E\u4E0D\u4EA4\u53C9"), "\u2014\u2014\u907F\u514D\u591A\u4EBA\u91CD\u590D\u5904\u7406\u540C\u4E00\u9700\u6C42"))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "status-flow"
  }, /*#__PURE__*/React.createElement("h2", null, "\u91C7\u8D2D\u8BA2\u5355\u72B6\u6001\u6D41\u8F6C"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: statusChart
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: statusColumns,
    data: statusData,
    pagination: false,
    size: "default",
    border: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "methods"
  }, /*#__PURE__*/React.createElement("h2", null, "\u8BE2\u4EF7 vs \u7ADE\u4EF7 vs \u76F4\u63A5\u4E0B\u5355"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: methodColumns,
    data: methodData,
    pagination: false,
    size: "default",
    border: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "change"
  }, /*#__PURE__*/React.createElement("h2", null, "\u8BA2\u5355\u53D8\u66F4"), /*#__PURE__*/React.createElement("blockquote", null, "\u5DF2\u786E\u8BA4\u7684\u8BA2\u5355\u53EF\u4EE5\u53D8\u66F4\uFF0C\u4F46\u6BCF\u6B21\u53D8\u66F4\u90FD\u4FDD\u7559\u5B8C\u6574\u5386\u53F2\u7248\u672C\u3002"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "\u53D8\u66F4\u6D41\u7A0B\uFF1A"), "\u521B\u5EFA\u53D8\u66F4\u5355 \u2192 \u4FEE\u6539\u7269\u6599\u9879\uFF08\u6570\u91CF/\u4EF7\u683C/\u4EA4\u671F\uFF09\u2192 \u5BA1\u6279 \u2192 \u751F\u6548"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "\u53D8\u66F4\u7684\u5F71\u54CD\uFF1A"), "\u7CFB\u7EDF\u53EA\u8C03\u6574\u53D7\u5F71\u54CD\u7684\u90E8\u5206\uFF0C\u5DF2\u53D1\u8D27/\u5DF2\u6536\u8D27\u7684\u884C\u4E0D\u53D7\u5F71\u54CD\u3002")), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "delivery-alert"
  }, /*#__PURE__*/React.createElement("h2", null, "\u4EA4\u671F\u9884\u8B66"), /*#__PURE__*/React.createElement("blockquote", null, "\u4EA4\u8D27\u65E5\u524D 3 \u5929\uFF0C\u7CFB\u7EDF\u81EA\u52A8\u5411\u4F9B\u5E94\u5546\u53D1\u9001\u786E\u8BA4\u8BF7\u6C42\u3002"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: deliveryAlertChart
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "supplier-view"
  }, /*#__PURE__*/React.createElement("h2", null, "\u4F9B\u5E94\u5546\u89C6\u89D2\uFF08\u91C7\u8D2D\u65B9\u9700\u8981\u7406\u89E3\uFF09"), /*#__PURE__*/React.createElement("blockquote", null, "\u7AD9\u5728\u4F9B\u5E94\u5546\u7684\u89D2\u5EA6\uFF0C\u4ED6\u7684\u64CD\u4F5C\u8DEF\u5F84\u662F\uFF1A"), /*#__PURE__*/React.createElement("p", null, "\u6536\u5230\u8BE2\u4EF7/\u7ADE\u4EF7\u9080\u8BF7 \u2192 \u67E5\u770B\u56FE\u7EB8\u548C\u7269\u6599\u8BE6\u60C5 \u2192 \u5728\u7EBF\u62A5\u4EF7 \u2192 \u6536\u5230\u91C7\u8D2D\u8BA2\u5355 \u2192 \u786E\u8BA4 or \u78CB\u5546 \u2192 \u7B7E\u5408\u540C \u2192 \u53D1\u8D27 \u2192 \u5BF9\u8D26\u6536\u6B3E"), /*#__PURE__*/React.createElement("h3", null, "\u5173\u952E\u7406\u89E3"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "\u4F9B\u5E94\u5546\u770B\u5230\u7684\u4EF7\u683C\u662F\u4F60\u51FA\u7684\u4EF7\uFF08Offer\uFF09\uFF0C\u4ED6\u53EF\u4EE5\u62A5\u81EA\u5DF1\u7684\u4EF7\u683C\uFF08Quote\uFF09\u6765\u78CB\u5546"), /*#__PURE__*/React.createElement("li", null, "\u4F9B\u5E94\u5546\u53EF\u4EE5\u4E0B\u8F7D\u56FE\u7EB8\uFF0C\u7CFB\u7EDF\u8BB0\u5F55\u4ED6\u7684\u9605\u56FE\u7248\u672C"), /*#__PURE__*/React.createElement("li", null, "\u4F9B\u5E94\u5546\u53CD\u9988\u5EF6\u8FDF\u65F6\uFF0C\u4F60\u4F1A\u7B2C\u4E00\u65F6\u95F4\u6536\u5230\u9884\u8B66\u2014\u2014\u8FD9\u662F\u4ED6\u7ED9\u4F60\u7684\u4FE1\u53F7\uFF0C\u4E0D\u662F\u574F\u6D88\u606F"))));
}